import Optional from "optional-js";
import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import ThisModel from 'js/models/service.config.model';
import UserModel from 'js/models/userrelatedinfo.model';
import PaginatedCollection from 'js/models/services.paginated.collection';
import ServiceRowView from 'js/views/service.row.view';
import PaginatedView from 'js/views/pagination.view';
import Template from 'js/templates/services.hbs';
import SelectedServiceTemplate from 'js/templates/message-report.selected.service.hbs';
import i18n from 'l10n';
import SurveyPageConfigModel from 'js/models/survey.page.config.model';
import VoucherPageConfigModel from 'js/models/service.page.config.model';
import InstantWinPageConfigModel from 'js/models/instantwin.page.config.model';
import BaseCampaignOps from 'js/traits/base.campaign.ops';
import ServicePreset from 'js/models/service.preset';
import {ServiceTypes,Statuses} from 'js/serviceutil';
import Timelineable from 'js/traits/timelineable.trait';
import {delegateEvent} from "../utils/event.delegator";

import {_, Backbone} from "backboneAdapter";
import {debounce, el, mixin, on, tagName, template} from "../adapters/backbone-decorators";

require('interfaceAdapter');

@mixin(BaseCampaignOps)
@mixin(Timelineable)
@el("#edit-voucher")
@tagName('span')
@template(Template)
class ServicesView extends GenericView {
    totalServices = {"vouchers": 0, "surveys": 0, "optins": 0};
    vouchersCheckboxIsChecked = $('#vouchersCheckbox').is(":checked");
    surveysCheckboxIsChecked = $('#surveysCheckbox').is(":checked");
    optinsCheckboxIsChecked = $('#optinsCheckbox').is(":checked");
    activeCheckboxIsChecked = $('#activeCheckbox').is(":checked");
    endedCheckboxIsChecked = $('#endedCheckbox').is(":checked");
    draftCheckboxIsChecked = $('#draftCheckbox').is(":checked");
    templateParams = {};
    ServiceTypes = ServiceTypes;
    Statuses = Statuses;
    campaignTemplateTypeArray = {
        0: {
            resultCountElement:".notification-for-no-active-services",
            selectedSvc: "noServices",
        },
        1: {
            resultCountElement: ".filter-results-count-voucher",
            selectedElement: "#voucher-options .selected",
            selectedSvc: "vouchers",
            serviceTitle: "managevouchertitle",
            searchBoxMessageElement: "#novoucherssearch",
            templateType: "TELLODY_VOUCHER",
            viewElement: "voucherView"
        },
        3: {
            resultCountElement: ".filter-results-count-survey",
            selectedElement: "#survey-options .selected",
            selectedSvc: "surveys",
            serviceTitle: "managesurveytitle",
            searchBoxMessageElement: "#nosurveyssearch",
            templateType: "TELLODY_SURVEY",
            viewElement: "surveyView"
        },
        8: {
            resultCountElement: ".filter-results-count-optin",
            selectedElement: "#optin-options .selected",
            selectedSvc: "optins",
            serviceTitle: "manageoptintitle",
            searchBoxMessageElement: "#nooptinssearch",
            templateType: "EMAIL_OPTIN,QUIZ_OPTIN,INSTANT_WIN,PAY_PAL_PAYMENT",
            viewElement: "voucherView"
        },
        4: {
            selectedSvc: "vouchersAndSurveys",
            templateType: "TELLODY_VOUCHER,TELLODY_SURVEY",
        },
        9: {
            selectedSvc: "vouchersAndOptins",
            templateType: "TELLODY_VOUCHER,EMAIL_OPTIN,QUIZ_OPTIN,INSTANT_WIN,PAY_PAL_PAYMENT",
        },
        11: {
            selectedSvc: "surveysAndOptins",
            templateType: "TELLODY_SURVEY,EMAIL_OPTIN,QUIZ_OPTIN,INSTANT_WIN,PAY_PAL_PAYMENT",
        },
        12: {
            resultCountElement: ".filter-results-count",
            selectedElement: "#triggering-event .selected",
            selectedSvc: "all",
            serviceTitle: "survey.yourservices",
            searchBoxMessageElement: "#noservicessearch",
            templateType: "TELLODY_VOUCHER,TELLODY_SURVEY,EMAIL_OPTIN,QUIZ_OPTIN,INSTANT_WIN,PAY_PAL_PAYMENT",
            viewElement: "campaignView"
        }
    };

    campaignStatusArray = {
        0: {
            selectedStatus: "all"
        },
        1: {
            selectedStatus: "active"
        },
        3: {
            selectedStatus: "draft"
        },
        8: {
            selectedStatus: "ended"
        },
        4: {
            selectedStatus: "activeAndDraft"
        },
        9: {
            selectedStatus: "activeAndEnded"
        },
        11: {
            selectedStatus: "draftAndEnded"
        },
        12: {
            selectedStatus: "all"
        }
    };
    // had to initialize events as a function, because of class prototype construction priority
    // cannot use @on in this case without adding a class member function that calls
    // the mixed-in prototype's deleteDraftIconClicked, because the method does not belong to this proto
    events() {
        return {
            'click .draftDeleteIcon': 'deleteDraftIconClicked',
        }
    }

    constructor(options) {
        super(options);
        this.options = options || {};
        this.inSearch = false;
        this.totalLength = 0;
        this.collection = new PaginatedCollection();
        this.collection.on('sync', this.addAll, this);
        if (this.getOption("embedded")) {
            var trigger = this.getOption("trigger", 'false');
            if (trigger !== 'false') {
                const ieq = trigger.indexOf("=");
                if (ieq > -1) {
                    this.id = trigger.substring(ieq + 1,
                        trigger.length);
                    this.triggeredCampaignType = trigger.substring(0, trigger.indexOf("\\"));
                }
            }
            this.setTemplateCollectionData();
        }
        const cti = this.getCampaignTemplateInfo();
        this.viewElement = cti.viewElement;
        this.selectedElement = cti.selectedElement;

        const usedFor = this.getOption("usedFor");

        if (this.getOption("embedded")) {
            const campaignTemplateType = this.getOption("campaignTemplateType");
            const voucherForUniqueCode = this.getOption("voucherForUniqueCode");
            const surveyForUniqueCode = this.getOption("surveyForUniqueCode");
            if (campaignTemplateType === "SMART_NOTIFICATION") {
                //we need both following "else if" of voucher and survey, to minimize the number of requests happening
                //on event campaign configuration, since we initialize three VouchersView (one for trigger, one for Surveys and one for Vouchers)
                if (usedFor === "trigger") {
                    this.refreshServicePreview("campaign");
                } else if (usedFor === "voucher") {
                    if (voucherForUniqueCode) {
                        this.refreshServicePreview("voucher");
                    }
                } else if (usedFor === "survey") {
                    if (surveyForUniqueCode) {
                        this.refreshServicePreview("survey");
                    }
                }
            } else {
                if (voucherForUniqueCode) {
                    this.refreshServicePreview("voucher");
                }
                if (surveyForUniqueCode) {
                    this.refreshServicePreview("survey");
                }
            }
        }
    }

    render() {
        var self = this;
        if (!this.inSearch) {
            this.totalLength = this.collection.count;
        }
        /* this.totalLength has the collection's length
        ** in case of Filter (Vouchers/Surveys/Optins Checkbox),
        ** also check for "this.totalServices.surveys + this.totalServices.vouchers == 0 + this.totalServices.optins == 0"
        */
        var totalServices = this.totalServices.surveys + this.totalServices.vouchers + this.totalServices.optins;
        if (!this.totalLength && totalServices === 0) {
            self.showNoVouchersToSearchMessage();
            self.showNotificationForNoActiveServices();
            self.hideIconRocket();
            self.hideNumberOfActiveServices();
        } else {
            self.hideNoVouchersToSearchMessage();
            self.hideNotificationForNoActiveServices();
            self.showIconRocket();
            self.showNumberOfActiveServices();
        }

        if (this.pagination) {
            this.pagination.remove();
        }

        // Render collection the 1st time
        this.pagination = new PaginatedView({collection: this.collection});
        this.pagination.render();

        // Replace view's pagination
        this.$('#pagination').html(this.pagination.$el);

        this.drawTimeline("", "Service.htm", true);

        if (this.getOption("embedded")) {
            var totalCountOfServicesFound = this.pagination.collection.count;
            var currentDataCount = this.pagination.collection.length;
            self.updateServiceTotalCounters(currentDataCount, totalCountOfServicesFound);
            self.hideSpinners();
        }
        this.$(".heading").bind("click", this.toggleHelpAccordionText);

        //empty the service row container and re-add them
        this.$el.find("#pages-content").empty();
        self.collection.each(function (item) {
            self.addOne(item, self);
        });

        var campaignTemplateType = this.getCampaignTemplateInfo();
        var campaignStatusFilter = this.getCampaignStatusFilter();

        this.updateServiceTotalCounters(this.collection.length, this.collection.count);

        var selectedSvc = campaignTemplateType && campaignTemplateType.selectedSvc;
        var selectedStatus = campaignStatusFilter && campaignStatusFilter.selectedStatus;
        var filteredServices = `${this.vouchersCheckboxIsChecked ? i18n.t('managevouchertitle') + ", " : ""}${this.surveysCheckboxIsChecked ? i18n.t('managesurveytitle') + ", " : ""}${this.optinsCheckboxIsChecked ? i18n.t('manageoptintitle') + ", " : ""}`;
        var filteredStatuses = `${this.activeCheckboxIsChecked ? i18n.t('message.activeFilter') + ", " : ""}${this.draftCheckboxIsChecked ? i18n.t('message.draftsFilter') + ", " : ""}${this.endedCheckboxIsChecked ? i18n.t('message.endedFilter') + ", " : ""}`;

        if (!this.getOption("embedded")) {
            if (selectedSvc !== "all" || selectedStatus !== "all") {
                var filterText = `${i18n.t('message.filter')}:`;
                if(selectedSvc !== "all")
                    filterText += ` ${filteredServices.substring(0, filteredServices.length - 2)}`;
                if(selectedStatus !== "all")
                    filterText += `${selectedSvc !== "all" ? "," :""} ${i18n.t('message.status')}(${filteredStatuses.substring(0, filteredStatuses.length - 2)})`
                $("#filtersApplied").text(filterText);
                $("#filterAlert").show();
            } else {
                this.clearServiceCheckboxFilter();
            }
        }
    }

    hideSpinners() {
        var $triggering = $('#triggering-spinner');
        var css = $triggering.css('display');
        if (css !== 'none') {
            $triggering.hide();
        }
        var $voucher = $('#voucher-options-spinner');
        if ($voucher.css('display') !== 'none') {
            $voucher.hide();
        }
        var $survey = $('#survey-options-spinner');
        if ($survey.css('display') !== 'none') {
            $survey.hide();
        }
        //optin functionality should be added
    }

    showNoVouchersToSearchMessage() {
        this.$("#novoucherssearch").show();
    }

    hideNoVouchersToSearchMessage() {
        this.$("#novoucherssearch").hide();
    }

    showIconRocket(){
        this.$("#group-2").show();
    }
    hideIconRocket(){
        this.$("#group-2").hide();
    }

    showNumberOfActiveServices(){
        this.$("#idOfCombinations").show();
    }

    hideNumberOfActiveServices(){
        this.$("#idOfCombinations").hide();
    }

    showNotificationForNoActiveServices(){
        this.$("#notification-for-no-active-services") .show();
    };

    hideNotificationForNoActiveServices(){
        this.$("#notification-for-no-active-services") .hide();
    };

    showVouchersSearchBox() {
        this.$("#voucherssearchbox").show();
    }

    hideVouchersSearchBox() {
        this.$("#voucherssearchbox").hide();
    }

    toggleHelpAccordionText() {
        var selector = $(".heading");
        setTimeout(function () {
            if (!selector.hasClass("collapsed")) {
                selector.find("span").text(i18n.t("dashboard.helpaccordionpromptClose"));
            } else {
                selector.find("span").text(i18n.t("voucher.helpaccordionprompt"));
            }
        }, 0);
    }

    refreshOptinPreview(viewElement, selectedElement) {
        var campaignSelect = $(viewElement);

        var selected = $(selectedElement).parent();
        const selClass = selected.attr("class") || "";
        var tempCampaign = `<div class="${selClass}">`;
        tempCampaign += (selected.html() || "") + "</div>";
        campaignSelect.html(tempCampaign);
    }

    async refreshServicePreview(serviceType) {

        if (!serviceType) return;
        var servicePreview = $(`#${serviceType}View`);
        const triggeringCriterionExpression = this.getOption("trigger");
        var serviceId = serviceType === "voucher" ? this.getOption("voucherForUniqueCode") :
            serviceType === "survey"
                ? this.getOption("surveyForUniqueCode")
                : parseInt(triggeringCriterionExpression.replace(/.*campaignId=/, ""));

        //change serviceType to "survey" or "voucher" accordingly, so backend will retrieve the appropriate data
        serviceType = serviceType === "campaign"
            ? triggeringCriterionExpression.match(/^RedeemVoucherEvent/)
                ? "voucher"
                : triggeringCriterionExpression.match(/^SurveyAnswerRequest/)
                    ? "survey"
                    : triggeringCriterionExpression.match(/^EmailOptedInEvent/)
                        ? "optin"
                        : "instantWin"
            : serviceType;

        if (isNaN(serviceId)) {
            return;
        } //if isNan => No service is selected
        let response = await $.ajaxDefaultQ({
            url: '/CampaignCloud/Report/getDataForSelectedService',
            type: 'GET',
            dataType: "json",
            traditional: true,
            data: {serviceId, serviceType}
        });
        const {
            serviceRecipients,//its the `views` in case of Optin/InstantWin
            serviceParticipants,
            serviceWinners,
            serviceStatus,
            serviceCCC,
            startDate: createdOn,
            endDate: ending,
            id
        } = response;

        const title = Optional.ofNullable(serviceCCC.title).orElseGet(() => serviceType === "voucher" ?
            i18n.t("voucher.selectedvoucherwithnotitle") : i18n.t(`survey.noname${serviceCCC.description}`));

        const icon = Handlebars.helpers.getIconClassViaTypeAndDescription(serviceType, serviceCCC.description);
        const statusFgColor = serviceStatus === "ACTIVE"
            ? "emerald"
            : serviceStatus === "ENDED"
                ? "darkRed"
                : "orange";

        const serviceBackground = serviceType === "voucher" ? `ribbed-${Handlebars.helpers.tilecolorclass(id)}` :
            serviceType === "survey"
                ? `bbgg-${Handlebars.helpers.tilecolorclass(id)}`
                : `bbbggg-${Handlebars.helpers.tilecolorclass(id)}`;
        const serviceParticipantsText = serviceType === "voucher" ? i18n.t("voucher.vredeemed") :
            serviceType === "survey" ? i18n.t("survey.filledin") : i18n.t("message.countfilledin2", {count: serviceParticipants});

        const serviceData = {
            serviceRecipients,
            serviceParticipants,
            serviceStatus,
            startDate: Optional.ofNullable(createdOn).map(c => c.millis).orElse(null),
            ending: Optional.ofNullable(ending).map(e => e.millis).orElse(null),
            id,
            title,
            icon,
            statusFgColor,
            serviceBackground,
            serviceParticipantsText,
            serviceType,
            serviceWinners
        };
        const compiledServiceTemplate = Handlebars.compile(SelectedServiceTemplate);
        servicePreview.html(compiledServiceTemplate(serviceData));
    }

    async addAll() {
        var self = this;
        this.$('#pages-content').empty();
        var ids = {
            voucherIds: [],
            surveyIds: [],
            optinIds: [],
            instantWinIds: [],
            quizIds: [],
            payPalPaymentIds: []
        };
        this.collection.each(function (item) {
            var type = item.get("campaignTemplateType");
            var campaignId = item.get('campaignId');
            var ctt = self.ServiceTypes[type];
            if (campaignId !== 0) {
                ids[`${ctt}Ids`].push(campaignId);
            }
            item.set('recipients', 0);
            switch (ctt) {
                case "voucher":
                    item.set('timesRedeemed', 0);
                    item.set('pointsRedeemed', 0);
                    break;
                case "survey":
                    item.set('timesFilledIn', 0);
                    break;
                case "optin":
                    item.set("timesOptedIn", 0);
                    break;
                case "instantWin":
                case "quiz":
                    item.set("winners", 0);
                    item.set("participants", 0);
                    item.set("visits", 0);
                    break;
                case "payPalPayment":
                    item.set("buyers", 0);
                    break;
            }
        });

        if (this.options && this.options.embedded) {
            var totalCountOfServicesFound = this.collection.count;
            var currentDataCount = this.length;
            this.updateServiceTotalCounters(currentDataCount, totalCountOfServicesFound);
            this.hideSpinners();
        } else {
            let surveys, vouchers, optins;
            if (this.collection.extras) {
                let {TELLODY_SURVEY, TELLODY_VOUCHER, EMAIL_OPTIN, INSTANT_WIN, PAYPAL_PAYMENT, QUIZ_OPTIN} =
                    this.collection.extras;
                surveys = TELLODY_SURVEY || 0;
                vouchers = TELLODY_VOUCHER || 0;
                optins = (EMAIL_OPTIN || 0) + (INSTANT_WIN || 0) + (PAYPAL_PAYMENT || 0) + (QUIZ_OPTIN || 0);
            } else if (location.href.includes("Message.htm") || location.href.includes("Profile.htm")) {
                let {ACTIVE_SURVEYS, ACTIVE_VOUCHERS, ACTIVE_OPTINS} =
                    await $.getDefaultQ('/CampaignCloud/Report/countCCCActiveAdvancedServices');
                surveys = ACTIVE_SURVEYS;
                vouchers = ACTIVE_VOUCHERS;
                optins = ACTIVE_OPTINS;
            } else {
                let {TOTAL_SURVEYS, TOTAL_VOUCHERS, TOTAL_OPTINS} =
                    await $.getDefaultQ('/CampaignCloud/Report/countTotalServices');
                surveys = TOTAL_SURVEYS;
                vouchers = TOTAL_VOUCHERS;
                optins = TOTAL_OPTINS;
            }
            self.updateServiceCounters(surveys, vouchers, optins);
        }
        await self.getAdditionalInfoForServices(ids);
    }

    async getAdditionalInfoForServices(ids) {
        var self = this;

        try {
            let response = await $.ajaxDefaultQ({
                url: '/CampaignCloud/Report/getAdditionalInfoForServices',
                type: 'GET',
                dataType: "json",
                traditional: true,
                data: ids
            });
            self.collectionDataSetter(self, response);
            self.refreshOptinPreview(self.viewElement, self.selectedElement);
        } catch (error) {
            console.error(error);
        } finally {
            self.render();
        }
    }

    collectionDataSetter(self, dataSet) {
        _.each(dataSet, function (dataValuePair, attribute) {
            _.each(dataValuePair, function (value, key) {
                var model = self.collection.find(function (item) {
                    return item.get("campaignId").toString() === key;
                });
                if (model)
                    model.set(attribute, value);
            });
        });
    }

    addOne(item, self) {
        let message = item.get("message");
        let view;
        if (Optional.ofNullable(message).filter(m => m.length > 1000).isPresent()) {
            message = `${message.substring(0, 1000)}…`;
        }
        item.set({message: message});

        for (var i = 0; self.collection.extras.length; i++) {
            if (self.collection.extras[i][0] === item.get('campaignId')) {
                item.set('number-of-contacts', self.collection.extras[i][1]);
                break;
            }
        }

        if (this.getOption("embedded")) {
            var triggeringCriterionExpression = this.getOption("trigger");

            const triggeredCampaignType = triggeringCriterionExpression
                ? triggeringCriterionExpression.split("\\")[0]
                : null;


            view = new ServiceRowView({
                model: item,
                embedded: true,
                survey: this.getOption("survey"),
                voucher: this.getOption("voucher"),
                optin: this.getOption("optin"),
                instantWin: this.getOption("instantWin"),
                payPalPayment: this.getOption("payPalPayment"),
                quiz: this.getOption("quiz"),
                usedFor: this.getOption("usedFor"),
                triggeredCampaignType: triggeredCampaignType,
                id: this.id
            });

            this.$el.find("#pages-content").append(view.render().el);
        } else {
            var campaignTemplateType = item.get("campaignTemplateType");
            var ctt = self.ServiceTypes[campaignTemplateType];
            var options = {
                model: item,
                embedded: false,
            };
            if (ctt) options[ctt] = true;
            view = new ServiceRowView(options);
            if (ctt)
                this.$el.find("#pages-content").append(view.render().el);
            else
                $('#pages-content').append(view.render().el);
        }
        delegateEvent(view, this, "selected:service");
    }

    @on('click #apply-filters')
    filterByCheckbox() {
        // "type" filter
        this.vouchersCheckboxIsChecked = $('#vouchersCheckbox').is(":checked");
        this.surveysCheckboxIsChecked = $('#surveysCheckbox').is(":checked");
        this.optinsCheckboxIsChecked = $('#optinsCheckbox').is(":checked");

        // "status" filter
        this.activeCheckboxIsChecked = $('#activeCheckbox').is(":checked");
        this.draftCheckboxIsChecked = $('#draftCheckbox').is(":checked");
        this.endedCheckboxIsChecked = $('#endedCheckbox').is(":checked");

        var noTypeSelected = !this.vouchersCheckboxIsChecked && !this.surveysCheckboxIsChecked && !this.optinsCheckboxIsChecked;
        var noStatusSelected = !this.activeCheckboxIsChecked && !this.endedCheckboxIsChecked && !this.draftCheckboxIsChecked;

        if (noTypeSelected || noStatusSelected) {
            $.Notify.warn(i18n.t("voucher.atLeastOneCheckedFilter"));
            return;
        } else {
            var selectedSvc = this.getCampaignTemplateInfo().selectedSvc;
            var selectedStatus = this.getCampaignStatusFilter().selectedStatus;

            Backbone.history.navigate(`type/${selectedSvc}/status/${selectedStatus}`, {trigger: false, replace: true});
        }

        this.setTemplateCollectionData();
    }

    @on('click #clearFilter')
    clearServiceCheckboxFilter() {
        $("#filterAlert").hide();
        $(".filterApplied").text("");
        Backbone.history.navigate('type/all/status/all', {trigger: true, replace: true});
    }

    @debounce(800)
    @on('keyup .searchbox')
    searchByFilter() {
        var self = this;

        var filtersMap = {};
        var onlyActive = false;

        self.collection.search = false;
        if (this.getOption("embedded")) {
            this.collection.filters = true;
            onlyActive = true;
            filtersMap["endDate"] = new Date(this.getOption("sendDate", Date.now())).getTime();

            if(filtersMap["endDate"] == null)
                filtersMap["endDate"] = new Date(this.getOption("sendDate", Date.now())).getTime();

            filtersMap["campaignId"] = 0;
        } else {
            this.collection.filters = false;
        }

        var text;
        this.$('.searchbox').each(function (index, elem) {
            if ($(elem).hasClass('filter_voucher')) {
                text = $(elem).val().toLowerCase();

                if (text !== "") {
                    filtersMap["title"] = text;
                    self.collection.filters = true;
                }
                self.collection.search = self.collection.search || text;
            }
            if ($(elem).hasClass('filter_type')) {
                text = $(elem).val().toLowerCase();

                if (text !== "") {
                    filtersMap["type"] = text;
                    self.collection.filters = true;
                }
                //self.collection.url += "filter_message="+text;
                self.collection.search = self.collection.search || text;
            }
        });

        //`self.<service>CheckboxIsChecked` is used on Service.htm page
        //`self.options.<service>` is used on Campaign Configuration page
        let enabledServices = {
            voucher: self.vouchersCheckboxIsChecked || this.getOption("voucher"),
            survey: self.surveysCheckboxIsChecked || this.getOption("survey")
        };

        let enabledStatuses =  {
            active: this.activeCheckboxIsChecked,
            ended: this.endedCheckboxIsChecked,
            draft: this.draftCheckboxIsChecked
        };

        if (self.optinsCheckboxIsChecked) {
            enabledServices.optin = enabledServices.instantWin = enabledServices.payPalPayment = enabledServices.quiz = true;
        } else {
            enabledServices.optin = this.getOption("optin");
            enabledServices.instantWin = this.getOption("instantWin");
            enabledServices.payPalPayment = this.getOption("payPalPayment");
            enabledServices.quiz = this.getOption("quiz");
        }

        filtersMap.multipleCampaignTemplateType = this.addCampaignTemplateTypeFilter(enabledServices);
        if(enabledStatuses.active || enabledStatuses.ended || enabledStatuses.draft) {
            filtersMap.campaignStatusIs = this.addCampaignStatusFilter(enabledStatuses);
            self.collection.filters = true;
        }

        if (self.collection.filters) {
            self.collection.url = `${this.collectionUrl}?filtersMap=${encodeURIComponent(JSON.stringify(filtersMap))}&only_active=${onlyActive}`;
            self.inSearch = true;
        } else {
            self.collection.url = `${this.collectionUrl}?only_active=${onlyActive}`;
            self.inSearch = false;
        }

        self.collection.getFirstPage();
    }

    addCampaignTemplateTypeFilter(enabledServices) {
        const STI = _.invert(this.ServiceTypes);
        var a = _.chain(enabledServices)
            .pairs()
            .filter(e => e[1])
            .map(s => STI[s[0]])
            .value();

        return a.toString();
    }

    addCampaignStatusFilter(enabledStatuses) {
        const STI = _.invert(this.Statuses);
        var a = _.chain(enabledStatuses)
            .pairs()
            .filter(e => e[1])
            .map(s => STI[s[0]])
            .value();

        return a.toString();
    }

    getOption(option, defaultValue) {
        return Optional.ofNullable(this.options)
            .map(o => o[option])
            .or(() => Optional.ofNullable(defaultValue))
            .orElse(null);
    }

    @on('click .create-new-voucher')
    createNewVoucher(ev) {
        var self = this;
        this.createNewService(function (VCmodel) {
            var currentElementId = $(ev.currentTarget).attr("id");
            var servicePreset = ServicePreset.voucher[currentElementId];
            var voucherPageConfig = new VoucherPageConfigModel(servicePreset.config);
            var voucherConfig = self.createVoucherConfig(servicePreset.data);
            if (currentElementId !== "blankVoucher")
                VCmodel.set("description", currentElementId);
            VCmodel.set("voucherPageConfig", voucherPageConfig);
            VCmodel.set("voucherConfig", voucherConfig);
            VCmodel.set("campaignTemplateType", "TELLODY_VOUCHER");
            if (currentElementId === "seasonTicket") {
                VCmodel.set("monitoringDuration", 12);
                VCmodel.set("monitoringTimeInterval", "HOURS");
                VCmodel.set("intervallyUsable", true);
            }
        });
    }

    @on('click .create-new-survey')
    createNewSurvey(ev) {
        this.createNewService(function (VCmodel) {
            var currentElementId = $(ev.currentTarget).attr("id");
            var surveyPreset = ServicePreset.survey[currentElementId];
            var surveyPageConfig = new SurveyPageConfigModel(surveyPreset.config);
            if (surveyPreset.description)
                VCmodel.set("description", surveyPreset.description);
            VCmodel.set("surveyPageConfig", surveyPageConfig);
            VCmodel.set("campaignTemplateType", "TELLODY_SURVEY");
        });
        return false;
    }

    @on('click .create-new-emailOptin')
    createNewEmailOptin(ev) { //todo QUIZ_OPTIN
        this.createNewService(function (VCmodel) {
            var currentElementId = $(ev.currentTarget).attr("id");
            var optIn = ServicePreset.optIn[currentElementId];
            var surveyPageConfig = new SurveyPageConfigModel(optIn.config);
            VCmodel.set("description", optIn.description);
            VCmodel.set("surveyPageConfig", surveyPageConfig);
            VCmodel.set("campaignTemplateType", "EMAIL_OPTIN");
        });
        return false;
    }

    @on('click .create-new-payPalPaymentOptin')
    createNewPayPalPaymentOptin(ev) {
        this.createNewService(function (VCmodel) {
            var payPalPayment = ServicePreset.payPalPayment[$(ev.currentTarget).attr("id")];
            var surveyPageConfig = new SurveyPageConfigModel(payPalPayment.config);
            var instantWinPageConfig = new InstantWinPageConfigModel(payPalPayment.instantWinPageConfig);
            VCmodel.set("description", payPalPayment.description);
            VCmodel.set("surveyPageConfig", surveyPageConfig);
            VCmodel.set("instantWinPageConfig", instantWinPageConfig);
            VCmodel.set("campaignTemplateType", "PAY_PAL_PAYMENT");
        });
        return false;
    }

    @on('click #createNewInstantWin')
    @on('click #createNewSweepstake')
    createNewLottery(ev) {
        this.createNewService(function (VCmodel) {
            var typeOfInstantWin = $(ev.currentTarget).data("wintype");
            var instantWin = ServicePreset.instantWin[typeOfInstantWin === "instantWin" ? "instantWin" : "sweepStakes"];
            var instantWinPageConfig = new InstantWinPageConfigModel(instantWin.instantWinPageConfig);
            var surveyPageConfig = new SurveyPageConfigModel(instantWin.surveyPageConfig);
            VCmodel.set("description", instantWin.description);
            VCmodel.set("instantWinPageConfig", instantWinPageConfig);
            VCmodel.set("surveyPageConfig", surveyPageConfig);
            VCmodel.set("campaignTemplateType", "INSTANT_WIN");
        });
        return false;
    }

    @on('click #create-new-quiz')
    createNewQuiz(ev) {
        this.createNewService(function (VCmodel) {
            var currentElementId = $(ev.currentTarget).attr("id");
            const quizOptin = ServicePreset.quizOptin[currentElementId];
            var instantWinPageConfig = new InstantWinPageConfigModel(quizOptin.instantWinPageConfig);
            var surveyPageConfig = new SurveyPageConfigModel(quizOptin.config);
            VCmodel.set("description", quizOptin.description);
            VCmodel.set("instantWinPageConfig", instantWinPageConfig);
            VCmodel.set("surveyPageConfig", surveyPageConfig);
            VCmodel.set("campaignTemplateType", "QUIZ_OPTIN");
        });
        return false;
    }

    async createNewService(cb) {
        var VCmodel = new ThisModel();
        var userModel = new UserModel();

        try {
            let data = await userModel.fetch();

            VCmodel.set("lng", i18n.language);
            VCmodel.set("userId", data.userId);
            VCmodel.set("sender", data.username);

            cb(VCmodel);

            let model = await VCmodel.save(VCmodel.attributes);
            if (location.href.includes("Dashboard")) {
                location.href = `Service.htm#${model.id}`;
            } else {
                location.href = `#${model.id}`;
            }

        } catch (e) {
            console.error(e);
        }
    }

    @on('click #redeem')
    gotoRedeem(ev) {
        location.href = $(ev.currentTarget).attr("href");
        return false;
    }

    setTemplateCollectionData() {
        var self = this;
        this.templateParams = {};
        var filtersMap = {};
        var onlyActive = false;

        // Checks if the view is embedded in another view
        const optionV = this.getOption("voucher");
        const optionS = this.getOption("survey");
        const optionO = this.getOption("optin");
        if (this.getOption("embedded")) {
            onlyActive = true;
            let enabledServices = {
                voucher: optionV,
                survey: optionS,
                optin: optionO,
                instantWin: this.getOption("instantWin"),
                payPalPayment: this.getOption("payPalPayment"),
                quiz: this.getOption("quiz")
            };
            filtersMap.multipleCampaignTemplateType = this.addCampaignTemplateTypeFilter(enabledServices);

            this.collectionUrl = `${ThisModel.prototype.urlRoot}/advancedServices/WithFilters`;
            _.chain(enabledServices)
                .pairs()
                .filter(e => e[1])
                .forEach(k => this.templateParams[`select${$.capitalizeFirstLetter(k[0])}`] = true);


            var tempExecutionDate = this.getOption("sendDate", Date.now());

            if(tempExecutionDate != null)
                if(tempExecutionDate == i18n.t('now'))
                    tempExecutionDate = Date.now();
                else
                    tempExecutionDate = new Date(tempExecutionDate).getTime();

            // set a filter for services' `endDate`, so the user can not select a service that expires after the execution of the campaign
            filtersMap["endDate"] = tempExecutionDate

            filtersMap["campaignId"] = 0;

            if (self.id) {
                var usedFor = this.getOption("usedFor");
                if (usedFor === "trigger") {
                    filtersMap["dependencyCampaignIdForCampaignView"] = self.id;
                } else {
                    filtersMap["dependencyCampaignIdForServiceViews"] = self.id;
                }
            }

            // minimized code. the x=>x lambda checks each value for "truthyness",
            // so undefined, null, "", 0 are considered false and therefore filtered
            const avoidDependencies = [
                this.getOption("voucherForUniqueCode"),
                this.getOption("surveyForUniqueCode")
            ].filter(x => x).join(",");

            if (avoidDependencies)
                filtersMap["serviceIdsForAvoidingTriggeredCampaign"] = avoidDependencies;

            this.collection.filters = true;
        } else {
            let enabledStatuses =  {
                active: this.activeCheckboxIsChecked,
                ended: this.endedCheckboxIsChecked,
                draft: this.draftCheckboxIsChecked
            };

            if(enabledStatuses.active || enabledStatuses.ended || enabledStatuses.draft)
                filtersMap.campaignStatusIs = this.addCampaignStatusFilter(enabledStatuses);

            _.chain(enabledStatuses)
                .pairs()
                .filter(e => e[1])
                .forEach(k => {
                    this.templateParams[`select${$.capitalizeFirstLetter(k[0])}`] = true;
                });


            let enabledServices = {
                voucher: this.vouchersCheckboxIsChecked,
                survey: this.surveysCheckboxIsChecked,
                optin: this.optinsCheckboxIsChecked,
                instantWin: this.optinsCheckboxIsChecked,
                payPalPayment: this.optinsCheckboxIsChecked,
                quiz: this.optinsCheckboxIsChecked
            };
            filtersMap.multipleCampaignTemplateType = this.addCampaignTemplateTypeFilter(enabledServices);

            _.chain(enabledServices)
                .pairs()
                .filter(e => e[1])
                .forEach(k => {
                    this.templateParams[`select${$.capitalizeFirstLetter(k[0])}`] = true;
                });

            this.templateParams.servicesCountClass = ((this.vouchersCheckboxIsChecked ? 1 : 0) + (this.surveysCheckboxIsChecked ? 1 : 0) + (this.optinsCheckboxIsChecked ? 1 : 0)) > 1
                ? ""
                : (this.vouchersCheckboxIsChecked
                    ? "-voucher"
                    : (this.surveysCheckboxIsChecked ? "-survey" : "-optin")
                );



            this.collectionUrl = `${ThisModel.prototype.urlRoot}/advancedServices/WithFilters`;
            this.collection.filters = enabledServices.voucher || enabledServices.survey || enabledServices.optin || enabledServices.instantWin || enabledServices.payPalPayment || enabledServices.quiz;
        }

        if (this.collection.filters) {
            this.collection.url = `${this.collectionUrl}?filtersMap=${JSON.stringify(filtersMap)}&only_active=${onlyActive}`;
        } else {
            this.collection.url = `${this.collectionUrl}?only_active=${onlyActive}`;
        }

        this.templateParams.length = this.collection.count;
        var templateOutput = this.template(this.templateParams);
        this.$el.html(templateOutput);

        self.collection.getFirstPage();
    }

    serviceCountersCallback(servicesCounters, titleToChange, $searchBoxMessageElement) {
        $('#all-services-count').text(
            `${servicesCounters.surveys} ${i18n.t("survey.surveyword", {count: servicesCounters.surveys})}, ${
                servicesCounters.vouchers} ${i18n.t("voucher.voucherword", {count: servicesCounters.vouchers})}, ${
                servicesCounters.optins} ${i18n.t("optin.optinword", {count: servicesCounters.optins})}`
        );

        this.totalServices = servicesCounters;
        var resultsCount = servicesCounters.vouchers + servicesCounters.surveys + servicesCounters.optins;
        $('#title').text(i18n.t(titleToChange));
        if (resultsCount === 0)
            $searchBoxMessageElement.show(); //show `no Search Box message`
    }

    updateServiceCounters(surveys, vouchers, optins) {
        surveys = surveys || 0;
        vouchers = vouchers || 0;
        optins = optins || 0;
        var isVouchersSelected = this.templateParams.selectVoucher;
        var isSurveysSelected = this.templateParams.selectSurvey;
        var isOptinsSelected = this.templateParams.selectOptin;

        var servicesCounters = {
            vouchers: isVouchersSelected ? vouchers : 0,
            surveys: isSurveysSelected ? surveys : 0,
            optins: isOptinsSelected ? optins : 0
        };

        var servicesCount = servicesCounters.vouchers + servicesCounters.surveys + servicesCounters.optins;
        $('.filter-messages-count').html(i18n.t("outOf", {n: this.collection.length, m: servicesCount}));

        var campaignTemplateType = this.getCampaignTemplateInfo();

        var searchBoxMessageElement;
        var titleToChange;
        if (campaignTemplateType) {
            titleToChange = campaignTemplateType.serviceTitle;
            searchBoxMessageElement = campaignTemplateType.searchBoxMessageElement;
        }

        let $sbme = $(searchBoxMessageElement);
        $sbme.hide();
        this.serviceCountersCallback(servicesCounters, titleToChange, $sbme);
    }

    updateServiceTotalCounters(collectionSize, totalFoundCount) {
        $(this.getCampaignTemplateInfo().resultCountElement).text(i18n.t("outOf", {
            n: collectionSize,
            m: totalFoundCount
        }));
    }

    createVoucherConfig(data) {

        var maximumNumberOfRedemptionMessages = 20;
        var voucherConfig = {
            cycle: false,
            redemptionMessages: [],
            redemptionMessageCount: 1
        };

        for (var i = 0; i < maximumNumberOfRedemptionMessages; i++) {
            voucherConfig.redemptionMessages.push({count: 0, message: null});
        }

        //overwrite messages with the custom ones (leave the default ones, if none are specified)
        var customRedemptionMessages = voucherConfig.redemptionMessages;
        _.each(data.redemptionMessages, function (item, index) {
            customRedemptionMessages[index] = item;
        });

        voucherConfig.redemptionMessageCount = Optional.ofNullable(data.redemptionMessageCount).orElse(1);
        voucherConfig.cycle = Optional.ofNullable(data.cycle).orElse(false);

        return voucherConfig;
    }

    getCampaignStatusFilter() {
        //use a different number (which will be `the_sum_of_the_previous_ones + 1`) for each status, so we will always get a different output.
        var selectedStatusesIndexNumber;
        if (this.getOption("embedded")) {
            selectedStatusesIndexNumber = 1; // only active, in embedded cases
        } else {
            selectedStatusesIndexNumber = ((this.activeCheckboxIsChecked ? 1 : 0) + (this.draftCheckboxIsChecked ? 3 : 0) + (this.endedCheckboxIsChecked ? 8 : 0));
        }
        const cti = this.campaignStatusArray[selectedStatusesIndexNumber];
        //complete the default values from the "all" type
        if (cti && selectedStatusesIndexNumber < 12)
            return _.chain(cti).clone().defaults(this.campaignStatusArray[12]).value();

        return cti;
    }

    getCampaignTemplateInfo() {
        //use a different number (which will be `the_sum_of_the_previous_ones + 1`) for each service, so we will always get a different output.
        var selectedServicesIndexNumber;
        if (this.getOption("embedded")) {
            selectedServicesIndexNumber = ((this.getOption("voucher") ? 1 : 0) + (this.getOption("survey") ? 3 : 0) + (this.getOption("optin") ? 8 : 0));
        } else {
            selectedServicesIndexNumber = ((this.vouchersCheckboxIsChecked ? 1 : 0) + (this.surveysCheckboxIsChecked ? 3 : 0) + (this.optinsCheckboxIsChecked ? 8 : 0));
        }
        const cti = this.campaignTemplateTypeArray[selectedServicesIndexNumber];
        //complete the default values from the "all" type
        if (cti && selectedServicesIndexNumber < 12)
            return _.chain(cti).clone().defaults(this.campaignTemplateTypeArray[12]).value();

        return cti;
    }

    @on('click #filter-button')
    toggleServiceFiltersAccordion() {
        $("#hidden-filter-button").trigger("click");
    }
}

// Returning instantiated views can be quite useful for having "state"
export default ServicesView;
